//
// Projects
// ---------------------------

@import "../../styles/colors";

.root {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
}

.container {
  position: relative;
  width: 100vw;
}

.image {
  display: block;
  width: 100%;
  min-width: 100% !important;
}
